import {hasKey} from "./hasKey";


/**
 * Group an array of objects by a key of the object in array
 * any object in the array that does not have the key will be grouped under 'default' key
 * @param value
 * @param groupSelector
 */
export function groupBy<T extends {[key: string|number|symbol]: any}, K extends keyof T >(value: Array<T>, groupSelector: K): T[][] {
    return Object.values(value.reduce( (acc: any, cur: T)=>{
        hasKey(cur, groupSelector)
            ? acc[cur[groupSelector]] = [...(acc[cur[groupSelector]] || []), cur]
            : acc['default'] = [...(acc['default'] || []), cur];
        return acc;
    }, {} as {[key: string|number|symbol]: T[]}));
}